<template>
	<div
		class="container h-100 d-flex align-items-center justify-content-center"
	>
		<div class="error-template">
			<img :src="host" alt="logotipo" class="mb-5" />
			<h1>Oops!</h1>
			<h2>{{ getTitle }}</h2>
			<p
				class="error-details"
				v-html="getMainText.replace(/\n/g, '<br>')"
			></p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "NotFound",
	data() {
		return {
			host:
				"https://s3-medex-partners.s3.amazonaws.com/" +
				location.hostname.replace("www.", "") +
				".png",
		};
	},
	computed: {
		...mapGetters({}),
		getTitle() {
			switch (this.$route.params.code) {
				case 404:
					return "Página não encontrada";
				case "expired":
					return "Prazo para entrada expirado";
				case "equipment":
					return "Equipamento incompatível";
				case "user":
					return "Usuário não encontrado";
				case "token":
					return "Código/token não encontrado";
				case "notFound":
					return "Cadastro não encontrado";
				case "notFoundTEM":
					return "CPF não encontrado";
				case "scheduleNotFound":
					return "Agendamento não encontrado";
				case "inactive":
					return "Cadastro inativo ou suspenso";
				case "tokenAlreadyUsed":
					return "Código/token já utilizado";
				case "inactiveFam":
					return "Cadastro não encontrado";
				case "notFoundProfarma":
					return "Cadastro não encontrado";
				default:
					return "Erro desconhecido";
			}
		},
		getMainText() {
			switch (this.$route.params.code) {
				case 404:
					return "Favor verificar seu link de acesso e tentar novamente.";
				case "expired":
					return "Você demorou mais de 5 minutos para entrar na sala e por isto a consulta foi encerrada. Por favor, entre de novo na fila e fique atento as mensagens no seu telefone ou na própria tela.";
				case "equipment":
					return "Infelizmente seu equipamento não é compatível com nosso sistema, pedimos por favor que você tente de outro dispositivo, aconselhamos o Google Chrome como navegador.";
				case "user":
					return "O usuário não foi encontrado, favor verificar os dados de acesso e tentar novamente.";
				case "token":
					return `O código do token ${
						this.$route.query?.token || ""
					} não foi enviado para a nossa base de dados pelo SIRE, por favor entre em contato com o administrador da sua região para ver o que pode ser feito.\nPedimos desculpas pelo transtorno!`;
				case "notFound":
					return "Seu cadastro não foi encontrado, por favor, entre em contato com o seu corretor.";
				case "notFoundTEM":
					return `CPF ${
						this.$route.query?.cpf || ""
					} não foi encontrado na nossa base de dados!\nPor favor entre em contato com 0800 8368836 para verificar o que pode estar acontecendo.\nDesde já obrigado e desculpe pelo transtorno.`;
				case "notFoundProfarma":
					return "CPF não encontrado, abra um chamado no SIC Profarma.";
				case "scheduleNotFound":
					return "Seu agendamento não foi encontrado, por favor, entre em contato com o seu corretor.";
				case "inactive":
					return "Seu cadastro está inativo ou suspenso, por favor, entre em contato com seu corretor.";
				case "tokenAlreadyUsed":
					return `O código do token ${
						this.$route.query?.token || ""
					} não pode ser mais utilizado por ele já ter sido utilizado em uma consulta ou o usuário ter faltado ao reagendamento permitido.\nProcure o administrador da sua região.`;
				case "inactiveFam":
					return `Este CPF e/ou telefone de cadastro não foi encontrado. Você deve usar os mesmos dados cadastrados no Familhão.\nO benefício da teleconsulta médica gratuita é apenas para  assinantes ativos do Familhão que moram no Estado do Rio Grande do Sul.\nSe você é assinante do Familhão, mora no Estado do Rio Grande do Sul, e não está conseguindo se cadastrar, entre em contato com nosso time de atendimento através do link: <a href="https://familhao.tv/medexfamilhaoajuda" target="_blank">https://familhao.tv/medexfamilhaoajuda</a>`;
				default:
					return "Ocorreu um erro inesperado, favor tentar novamente mais tarde.";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.error-template {
	padding: 40px 15px;
	text-align: center;

	img {
		max-width: 200px;
		height: auto;

		@media screen and (max-width: 768px) {
			max-width: 150px;
		}
	}
}
.error-actions {
	margin-top: 15px;
	margin-bottom: 15px;
}
.error-actions .btn {
	margin-right: 10px;
}
</style>
